import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	parallelSprintsTitle: {
		id: 'products-jsw-configuration-main.features-section.parallel-sprints.parallel-sprints-title',
		defaultMessage: 'Parallel sprints for company-managed projects',
		description: 'Checkbox value',
	},
	parallelSprintsDescription: {
		id: 'products-jsw-configuration-main.features-section.parallel-sprints.parallel-sprints-description',
		defaultMessage:
			"Allow multiple sprints to run at the same time. This feature doesn't apply to team-managed projects.",
		description: 'Description for the checkbox label',
	},
	parallelSprintsToggleLabelOptingIn: {
		id: 'products-jsw-configuration-main.features-section.parallel-sprints.parallel-sprints-toggle-label-opting-in',
		defaultMessage: 'Toggle on parallel sprints',
		description: 'Button to toggle the parallel sprint feature on',
	},
	parallelSprintsToggleLabelOptingOut: {
		id: 'products-jsw-configuration-main.features-section.parallel-sprints.parallel-sprints-toggle-label-opting-out',
		defaultMessage: 'Toggle off parallel sprints',
		description: 'Button to toggle the parallel sprint feature off',
	},
});
